import { configureRequest } from "@asosteam/asos-web-request";
import noticeError from "src/app/utilities/noticeError";
import logger from "src/app/utilities/logger";

export default async function isLiveChatAvailable(
  storeCode = "COM",
  language = "en-GB"
) {
  try {
    const request = configureRequest({
      logger,
      client: {
        name: "asos-contentweb-customer-care-help-pages",
        version: "1.0.0",
        platform: "CPT",
      },
    });

    const url = `/api/care/helpcontact/v1/chatbuttonavailable?store=${storeCode}&lang=${language}&page=MP`;
    const response = await request.get({
      url,
    });

    const chatNow = response.data.chatAvailable;

    return chatNow;
  } catch (error) {
    noticeError(error);

    return false;
  }
}
